import script from "./SalesReceiptView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesReceiptView.vue?vue&type=script&setup=true&lang=js"

import "./SalesReceiptView.vue?vue&type=style&index=0&id=63f90c10&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f90c10"]])

export default __exports__